import { Document } from '@react-pdf/renderer';
import ExportPdfContext from './ExportPdfContext';
import { PdfDocumentData } from './exportPdfTypes';
import PdfProductsPageCompact from './Pages/PdfProductsPageCompact';
import PdfProductsPageFull from './Pages/PdfProductsPageFull';

export const getDocument = ({ settings, seller, products, fileName, pageStartingNumber }: PdfDocumentData) => {
    return (
        <ExportPdfContext.Provider
            value={{
                orientation: settings.useLandscape ? 'landscape' : 'portrait',
                pageStartingNumber,
            }}
        >
            <Document title={fileName}>
                {settings.useCompactLayout ? (
                    <PdfProductsPageCompact products={products} seller={seller} />
                ) : (
                    <PdfProductsPageFull
                        products={products}
                        showVariationImages={!!settings.showVariationImages}
                        showImagePicture={!!settings.showImagePicture}
                        seller={seller}
                    />
                )}
            </Document>
        </ExportPdfContext.Provider>
    );
};
